module.exports = __webpack_public_path__ + "img/horizontal_3_6_8003.4332ec0b.png";